import React, { lazy, useEffect, useState } from "react";
import { Route, Switch } from "react-router";
import { withRouter, useRouteMatch } from "react-router-dom";
import { getCurrentLocale } from "../../../store/intl/intlSelectors";
import { connect } from "react-redux";

import "./HomePage.scss";
// components
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Content from "./components/Content";
import EmailConfirmationModal from "./components/EmailConfirmationModal"
// legal documents
const PrivacyPolicy = lazy(() => import("./legalDocuments/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("./legalDocuments/TermsOfUse"));
const ConditionsOfUse = lazy(() => import("./legalDocuments/ConditionsOfUse"));

const HomePage = ({ currentLocale, locale }) => {
  const { path } = useRouteMatch();
  const [isModalShown, setIsModalShown] = useState(false)
  const [isAlreadyVerified, setIsAlreadyVerified] = useState(false)

  useEffect(()=> {
    const isEmailConfirmed = new URLSearchParams(window.location.search).get('email-confirmation')
    if (isEmailConfirmed === "true") {
      setIsModalShown(true)
    } else if (isEmailConfirmed === "false") {
      setIsModalShown(true)
      setIsAlreadyVerified(true)
    }

    document.querySelector("html").classList.add("landing-page");
    return () => {
      document.querySelector("html").classList.remove("landing-page");
    };
  }, [currentLocale]);

  return (
    <>
      {isModalShown && <EmailConfirmationModal isAlreadyVerified={isAlreadyVerified} handleModalShown={setIsModalShown} />}
      <div id="home-page">
        <Navigation currentLocale={currentLocale} locale={locale} />
        <Switch>
          <Route exact path={path}>
            <Content currentLocale={currentLocale} />
          </Route>
          <Route path={`/privacy-policy`}>
            <PrivacyPolicy currentLocale={currentLocale} />
          </Route>
          <Route path={`/terms-of-use`}>
            <TermsOfUse currentLocale={currentLocale} />
          </Route>
          <Route path={`/conditions-of-use`}>
            <ConditionsOfUse currentLocale={currentLocale} />
          </Route>
  			</Switch>
        <Footer />
      </div>
    </>
  );
};
const mapState = (state) => ({
  currentLocale: getCurrentLocale(state),
});

export default withRouter(connect(mapState)(HomePage));
